document.addEventListener('DOMContentLoaded', () => {
  const stickyBars = document.querySelectorAll('[data-sticky-bar]');
  if (stickyBars.length === 0) return;

  const hero = document.querySelector('[id^="lh-landings-hero-"]');
  const heroBottom = hero ? hero.offsetTop + hero.offsetHeight : 0;
  const triggerOffset = heroBottom * 0.65;

  const updateVisibility = () => {
    const scrollY = window.scrollY;
    const isPastHero = scrollY > triggerOffset;

    stickyBars.forEach((bar) => {
      bar.classList.toggle('is-visible', isPastHero);
    });
  };

  window.addEventListener('scroll', () => {
    window.requestAnimationFrame(updateVisibility);
  }, { passive: true });

  updateVisibility();

  // Add to cart forms
  stickyBars.forEach((bar) => {
    const atcForm = bar.querySelector('[data-sticky-bar-atc]');
    if (!atcForm) return;

    atcForm.addEventListener('submit', (event) => {
      event.preventDefault();
      const submitButton = atcForm.querySelector('button[type="submit"]');
      window.lhLandingsAddToCart(atcForm, submitButton);
    });
  });
});
